<section class="@container flex h-full w-full flex-col" [formGroup]="form">
  <div class="flex flex-1 flex-col gap-2">
    <!-- FREQUENCY SELECTOR -->
    <div class="flex flex-col">
      <mat-button-toggle-group
        class="w-full overflow-hidden [&_.mat-button-toggle]:flex-1 [&_.mat-button-toggle-label-content]:!p-3 [&_.mat-button-toggle-label-content]:!text-sm"
        hideSingleSelectionIndicator
        [formControlName]="controlNames.FREQUENCY"
      >
        @for (option of frequencyOptions; track option) {
          <mat-button-toggle [value]="option">{{ 'CRON_CONFIGURATOR.FREQUENCY.' + option | translate }}</mat-button-toggle>
        }
      </mat-button-toggle-group>
    </div>

    <!-- FORM FIELDS -->
    <div class="mt-4 flex w-full flex-wrap items-start gap-4">
      @if (frequency() === CronFrequency.WEEKLY) {
        <mat-form-field color="accent" class="flex-1">
          <mat-label>{{ 'CRON_CONFIGURATOR.DAY_OF_WEEK' | translate }}</mat-label>
          <mat-select [formControlName]="controlNames.WEEK_DAY">
            @for (day of weekDays; track day.value) {
              <mat-option [value]="day.value">{{ 'CRON_CONFIGURATOR.DAYS.' + day.label | translate }}</mat-option>
            }
          </mat-select>
        </mat-form-field>
      }

      @if (frequency() === CronFrequency.MONTHLY) {
        <mat-form-field color="accent" class="flex-1">
          <mat-label>{{ 'CRON_CONFIGURATOR.DAY_OF_MONTH' | translate }}</mat-label>
          <mat-select [formControlName]="controlNames.MONTH_DAY">
            @for (day of monthDays; track day) {
              <mat-option [value]="day">{{ day }}</mat-option>
            }
          </mat-select>
        </mat-form-field>
      }

      <mat-form-field color="accent" class="flex-1">
        <mat-label>{{ 'CRON_CONFIGURATOR.TIME' | translate }}</mat-label>
        <input matInput [matTimepicker]="timePicker" [formControlName]="controlNames.TIME" />
        <mat-timepicker-toggle matSuffix [for]="timePicker" />
        <mat-timepicker #timePicker />
      </mat-form-field>
    </div>
  </div>
</section>
